<app-top-bar
	[transportId]="store.transport()?.id"
	[module]="TransportModule.TIMETABLE"
	[side]="store.transport()?.side ?? TransportSide.DEPARTURE"
	[buttonsDisabled]="store.transportAction() === TransportAction.ADD"
	[transportName]="store.transport()?.name"
	[kind]="store.transport()?.kind"
	[transportsToLinkNames]="store.transportsToLinkNames()"
	(saveTransportTimetableEvent)="saveTimetable()"
>
</app-top-bar>

@if (store.someRequestIsLoading()) {
	<div class="w-100 vh-100">
		<app-custom-mat-loader></app-custom-mat-loader>
	</div>
} @else {
	<mat-card-title
		[ngStyle]="{ top: matCardTitleTopPosition }"
		class="d-flex justify-content-center bg-white py-3 px-3 z-2 position-sticky shadow-sm align-items-center"
	>
		<div class="w-25 d-flex justify-content-start">
			@if (transportKind() === OfferTransportKind.COACH) {
				<mat-slide-toggle
					(change)="store.updateCalculateTimeDepartures($event.checked)"
					[checked]="store.calculateTimeDepartures()"
					color="primary"
				>
					Przeliczaj godziny automatycznie
				</mat-slide-toggle>
			}
		</div>

		<div class="d-flex justify-content-between" style="font-size: 16px">
			@for (item of stopLegend | keyvalue; track item.key; let isLast = $last) {
				<div
					[ngClass]="{
						'border-end border-black pe-2 me-2': !isLast,
					}"
					class="d-flex align-items-center"
				>
					<div [ngStyle]="{ 'background-color': item.value.color }" class="me-2 legend-square"></div>
					{{ item.value.name }}
				</div>
			}
		</div>
		<div class="w-25 d-flex justify-content-end">
			@if (transportKind() === OfferTransportKind.PLANE) {
				<button class="me-2" (click)="openLuggageDialog()" mat-raised-button color="primary">
					Skonfiguruj bagaże
				</button>
			}
			<button (click)="changeToggleAllState()" mat-raised-button color="primary">Rozwiń/Zwiń wszystko</button>
		</div>
	</mat-card-title>

	<mat-card>
		<mat-card-content>
			<mat-accordion multi="true">
				@for (item of timetables(); track item.vehicle.id; let index = $index) {
					<mat-expansion-panel
						[expanded]="isExpandedPanelsArr[index].expanded"
						(expandedChange)="changeExpandedState(isExpandedPanelsArr[index], $event)"
					>
						<mat-expansion-panel-header>
							<mat-panel-title>
								@if (item.editableVehicle) {
									<mat-form-field>
										<mat-label>Wybierz pojazd</mat-label>
										<input
											(click)="filterVehiclesByName(item.vehicle); $event.stopPropagation()"
											type="text"
											matInput
											[ngModel]="item.vehicle"
											(ngModelChange)="filterVehiclesByName($event)"
											[matAutocomplete]="auto"
										/>
										<mat-autocomplete
											(optionSelected)="
												changeSelectedVehicle(item.vehicle, $event.option.value);
												item.editableVehicle = !item.editableVehicle
											"
											#auto="matAutocomplete"
											[displayWith]="displayFn"
										>
											@for (option of filteredOptionsWithoutSelectedVehicles(); track option.id) {
												<mat-option [value]="option.id">{{ option.name }}</mat-option>
											}
										</mat-autocomplete>
									</mat-form-field>
								} @else {
									<strong class="d-flex justify-content-center align-items-center"
										><span>Pojazd: {{ item.vehicle.name }}</span>
										<button
											class="d-flex justify-content-center align-items-center fs-5 ms-1"
											mat-icon-button
											(click)="
												item.editableVehicle = !item.editableVehicle; $event.stopPropagation()
											"
										>
											<i class="fa-solid fa-pencil"></i></button
									></strong>
								}
							</mat-panel-title>
							<mat-panel-description>
								@if (transportKind() !== OfferTransportKind.PLANE) {
									@if (item.vehicle.transportVehicleKind === TransportVehicleKind.ANTENNA) {
										Antenka <i class="fas ms-2 fa-car"></i>
									} @else if (item.vehicle.transportVehicleKind === TransportVehicleKind.BUS) {
										Autokar <i class="fas ms-2 fa-bus"></i>
									}
								}
							</mat-panel-description>
						</mat-expansion-panel-header>

						<ng-template matExpansionPanelContent>
							<app-transport-timetable-table
								[transportId]="store.transport()?.id"
								[timetables]="item.timetable"
								[vehicleId]="item.vehicle.id"
								[transportLogic]="item.transportLogic"
								[antennas]="item.antennasForVehicle"
								[timeDepartures]="store.timeDepartureMap().get(item.vehicle.id)"
								[timeDepartureMap]="store.timeDepartureMap()"
								[isExpandedPanelsArr]="isExpandedPanelsArr[index].antennas"
								[transportKind]="transportKind()"
								[filteredOptions]="filteredOptionsWithoutSelectedVehicles()"
								[side]="store.transport()?.side ?? TransportSide.DEPARTURE"
								[abroadAirportStops]="store.abroadAirportStops()"
								(timeDepartureChange)="
									updateTimeDeparture($event.timeDeparture, $event.id, $event.vehicleId)
								"
								(stopConnectionChange)="updateStopConnection($event)"
								(stopSaleChange)="updateStopSale($event.stopSale, $event.timetableId, $event.vehicleId)"
								(feeChange)="updateFee($event.fee, $event.timetableId, $event.vehicleId)"
								(flightNumberChange)="
									updateFlightNumber($event.flightNumber, $event.timetableId, $event.vehicleId)
								"
								(pauseDurationChange)="
									updatePauseDuration($event.pauseDuration, $event.timetableId, $event.vehicleId)
								"
								(abroadAirportStopChange)="
									updateAbroadAirportStop(
										$event.abroadAirportStop,
										$event.timetableId,
										$event.vehicleId
									)
								"
								(abroadAirportTimeChange)="
									updateAbroadAirportTime(
										$event.abroadAirportTime,
										$event.timetableId,
										$event.vehicleId
									)
								"
								(expansionStateChange)="changeExpandedState($event.expansionPanel, $event.valueToSet)"
								(filterVehiclesByNameChange)="filterVehiclesByName($event.value)"
								(changeSelectedVehicleChange)="
									changeSelectedVehicle($event.currentVehicle, $event.vehicleIdToUpdate)
								"
							></app-transport-timetable-table>
						</ng-template>
					</mat-expansion-panel>
				}
			</mat-accordion>
		</mat-card-content>
	</mat-card>
}
